import React from "react";
import Layout from "layout/index.js";
import Main from "./components/Main/Main";
import Hero from "components/Hero/Hero";
import privacyImage from "assets/privacyImage.png";
import { useLocation } from "react-router-dom";

const Privacypolicy = () => {
  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [location.key]);
  return (
    <Layout hr>
      <Hero
        path={"Home / Privacy Policy"}
        title={"Privacy Policy"}
        lastUpdated={"Last Updated: June 5, 2024"}
        image={privacyImage}
      />
      <Main />
    </Layout>
  );
};

export default Privacypolicy;
